import LeadershipBoardWidget from './LeadershipBoardWidget'

export default LeadershipBoardWidget
